import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../../../constants/dataAids';
import {
  OlsConfigStore,
  RouteHandler,
  ScrollWidgetActions
} from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import * as Metrics from '../utils/trackMetric';
import * as MetricEvents from '../../../constants/metrics';
import DeviceText from '../DeviceText';

export const sortOptionClickMetricMap = {
  descend_by_popularity: MetricEvents.SORT_DROPDOWN_DESCEND_BY_POPULARITY_CLICK,
  descend_by_created_at: MetricEvents.SORT_DROPDOWN_DESCEND_BY_CREATED_AT_CLICK,
  ascend_by_price: MetricEvents.SORT_DROPDOWN_ASCEND_BY_PRICE_CLICK,
  descend_by_price: MetricEvents.SORT_DROPDOWN_DESCEND_BY_PRICE_CLICK,
  ascend_by_name: MetricEvents.SORT_DROPDOWN_ASCEND_BY_NAME_CLICK,
  descend_by_name: MetricEvents.SORT_DROPDOWN_DESCEND_BY_NAME_CLICK
};

export const SORTING_KEYS = [
  'descend_by_popularity',
  'descend_by_created_at',
  'ascend_by_name',
  'descend_by_name',
  'ascend_by_price',
  'descend_by_price'
];

const getStyles = ({ withBorder }) => ({
  button: {
    'borderWidth': withBorder ? '1px' : '0',
    'borderColor': 'section',
    'borderStyle': 'solid',
    'display': 'flex',
    'justifyContent': 'center',
    'alignItems': 'center',
    'cursor': 'pointer',
    'height': '51px',
    'color': 'section',
    '@sm': {
      alignItems: 'baseline'
    }
  },
  menu: {
    color: 'inherit'
  },
  dropdown: {
    'position': 'absolute',
    'top': '58px',
    'left': '4px',
    'right': '2px',
    'zIndex': '10',
    'borderWidth': '1px',
    'borderColor': 'section',
    'borderStyle': 'solid',
    'borderRadius': 0,
    'margin': 0,
    'boxShadow': 'none',
    'paddingHorizontal': '30px',
    'paddingVertical': '32px',
    '@sm': {
      top: '26px',
      left: 'auto',
      right: '-xxsmall',
      width: '260px'
    }
  },
  listItem: {
    cursor: 'pointer',
    display: 'block',
    margin: '0',
    padding: '2px 0'
  }
});

const SortDropdown = props => {
  const { MoreLink, Dropdown, ListItem, Link } = UX2.Element;
  const { Nav } = UX2.Group;
  const {
    translate,
    currentView,
    currentSortOption,
    selectedTaxonPermalink,
    routePath,
    searchKeywords,
    withBorder
  } = props;
  const styles = getStyles({ withBorder });

  const [showDropdown, setShowDropdown] = useState();
  const toggleDropdown = () => setShowDropdown(prev => !prev);

  useEffect(() => {
    Metrics.track(MetricEvents.SORT_DROPDOWN_IMPRESSION);
    if (searchKeywords && OlsConfigStore.getState().use_best_match) {
      SORTING_KEYS.unshift('descend_by_match');
    }
  }, []);

  const onSortDropdownChange = sortOption => {
    Metrics.track(sortOptionClickMetricMap[sortOption]);
    RouteHandler.navigate(currentView, {
      sortOption,
      page: 1, // we always default to the first page when we change the sortOption
      routePath,
      keywords: searchKeywords,
      taxonPermalink: selectedTaxonPermalink
    });
    ScrollWidgetActions.scrollShopWidget();
    toggleDropdown();
  };

  return (
    <Nav.Vertical id='filter-dropdown'>
      <DeviceText
        style={ styles.button }
        onClick={ toggleDropdown }
        data-aid={ dataAids.PRODUCT_SORT_DROPDOWN }
      >
        <MoreLink.Menu
          children={ translate(`products.sort_options.${withBorder ? 'label' : currentSortOption}`) }
          expanded={ showDropdown }
          style={ styles.menu }
        />
      </DeviceText>
      { showDropdown && (
        <Dropdown section='default' id='sortDropdown' style={ styles.dropdown }>
          { [...new Set(SORTING_KEYS)].map(key => (
            <ListItem
              data-aid={ `${dataAids.PRODUCT_SORT_DROPDOWN}.${key}` }
              key={ `filter-option-${key}` }
              style={ styles.listItem }
              onClick={ () => onSortDropdownChange(key) }
            >
              <DeviceText>
                { key === currentSortOption ? (
                  <Link.Active tag='span' children={ translate(`products.sort_options.${key}`) } />
                ) : (
                  <Link tag='span' children={ translate(`products.sort_options.${key}`) } />
                ) }
              </DeviceText>
            </ListItem>
          )) }
        </Dropdown>
      ) }
    </Nav.Vertical>
  );
};

SortDropdown.propTypes = {
  translate: PropTypes.func,
  currentView: PropTypes.any,
  currentSortOption: PropTypes.string,
  selectedTaxonPermalink: PropTypes.any,
  routePath: PropTypes.any,
  searchKeywords: PropTypes.any,
  withBorder: PropTypes.bool
};

export default SortDropdown;
